import { render } from "./AllFeedback.vue?vue&type=template&id=49a64806&ts=true"
import script from "./AllFeedback.vue?vue&type=script&lang=ts"
export * from "./AllFeedback.vue?vue&type=script&lang=ts"

import "./AllFeedback.vue?vue&type=style&index=0&id=49a64806&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__